'use client';

import { motion } from 'framer-motion';
import { Display, PinkButton, GlassButton } from '../ui';

export default function HeroSection() {
  return (
    <section className="relative mx-auto max-w-[1280px] overflow-hidden px-6 pb-28 pt-20 text-center">
      {/* social-proof pill with live ping dot. TODO(stat): real editor count. */}
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-8 inline-flex items-center gap-2 rounded-full border border-mk-pink/30 bg-mk-pink/10 px-4 py-1.5 font-mk-label text-xs font-bold uppercase tracking-[0.18em] text-mk-pink"
      >
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-mk-pink opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-mk-pink" />
        </span>
        1,200+ editors searching with Reclipt
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.05 }}
      >
        <Display as="h1" className="mb-6 text-6xl leading-none sm:text-7xl md:text-8xl">
          One archive.
          <br />
          <span className="text-mk-pink">Endless moments.</span>
        </Display>
        <p className="mx-auto mb-10 max-w-2xl font-mk-body text-lg text-mk-muted">
          Reclipt is the fastest way to turn thousands of hours of raw footage
          into a searchable, clip-ready library.
        </p>
        <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
          <PinkButton href="/register" size="lg">
            Start Searching Now
          </PinkButton>
          <GlassButton href="#talk" size="lg">
            Watch Demo
          </GlassButton>
        </div>
      </motion.div>

      {/* ambient pink glow */}
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-mk-pink/10 blur-[120px]" />
    </section>
  );
}
